import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/analytical-tools-contents/TopicOne";

const AnalyticalToolsContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Smart Trading Begins with Data</h2>
                <p>
                  Every successful trade starts with informed decisions. The
                  Pips Analytical Tools give you access to a comprehensive range
                  of technical and fundamental analytics, empowering you to
                  identify emerging opportunities, understand market movements,
                  and fine-tune your trading strategy. Whether you’re analyzing
                  price action or economic trends, these tools provide the
                  clarity you need to stay ahead. With customizable indicators
                  and real-time data updates, you can tailor your analysis to
                  match your unique trading style. The platform’s intuitive
                  interface ensures that even complex insights are easy to
                  interpret and apply. From short-term setups to long-term
                  forecasting, you’ll have the data advantage at every step.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Start Analyzing
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/analytical_tools/analytical_tools_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnalyticalToolsContentOne;
